import transactionsService from "api/transactionsService"
import { AxiosResponse } from "axios"
import { useQuery } from "react-query"
import { IGetTransactionsQueryParams, IGetTransactionsRes } from "types/transaction"

interface IUseGetTransactionsArgs {
  key: string
  query: IGetTransactionsQueryParams
  enabled: boolean
}

const useGetTransactions = ({ key, query,enabled }: IUseGetTransactionsArgs) => {
  return useQuery([key, {...query}], async () => {
    const res: AxiosResponse<IGetTransactionsRes> =  await transactionsService.getTransactions(query)

    return res.data
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetTransactions